import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../';
import { HttpClientService } from '../../../shared';
import { CookieManagerService, ErrorManagerService } from '../../../shared/';
import { Question, NavigationNumber } from '../../model';
import { QustionTypes, CookieNames, ApiEndpoints } from '../../constant';
import { DOCUMENT } from "@angular/platform-browser";
import { SubSubject } from '../../model';

@Component({
  selector: 'app-report-review',
  templateUrl: '../views/report-review.component.html',
  styleUrls: ['../../../css/report-review.component.css', '../../../css/paper.component.css', '../../../css/paper-sets.component.css']
})
export class ReportReviewComponent implements OnInit {
  public fixed: boolean = false;
  public clickId = 999;
  public questingViewingType: string = ApiEndpoints.questingViewingTypeReport;
  public subcategory: string;
  public category: string;
  public mark: number;
  public explanation: string;

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let num = window.document.body.scrollTop;
    if (num > 187) {
      this.fixed = true;
    } else if (this.fixed && num < 187) {
      this.fixed = false;
    }
  }

  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router) {
  }

  // quections: Array<Question>;
  qustion: Question;
  public answerArray: any = [];
  public qNumberArray: any = [];
  qustionTypes: any = QustionTypes;
  partid: string;
  paperid: string;
  categoryid: string;
  subject: string;
  subSubjects: any;
  questionLength: number;
  public index: number;
  // private filterQuection = [];


  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.partid = params['partid'];
      this.categoryid = params['categoryid'];
      this.subject = params['subject'];
    });
    this.paperid = this.cookieManagerService.getCookie(CookieNames.paperId, false).toString();
    this.index = 0
    this.getAnswerArray();
    // this.subSubjects = JSON.parse(this.cookieManagerService.getCookie(CookieNames.subjects, true));
    this.subjectCharts();
    window.scrollTo(0, 0);
  }

  getAnswerArray() {
    let array = [];
    let mainQuestion = 1;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getQuestionAnswers, {
      [ApiEndpoints.partid]: this.partid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      if (response) {
        this.answerArray = response;
        this.questionLength = response.length;
        this.getQuestion(this.answerArray[this.index].qId);//questionNumber);    
        let qnumberArray = this.arrangeItems(response);
        this.qNumberArray = NavigationNumber.fromJSONArray(qnumberArray, false);
      }
    });
  }

  arrangeItems(navList) {
    let indexNo: number = 0;
    var items = navList.reduce((p, c) => {
      let obj = {
        'q': {},
        'sq': []
      };

      if (!c.label.label) {
        obj.q = { 'label': c.label.qNumber, 'index': indexNo++, 'isCorrect': c.isCorrect, 'isSkiped': c.isSkiped, 'isLabel': true};
        return p.concat(obj);
      } else if (c.label.label && !c.label.label.qNumber) {
        if (c.label.label.qNumber != "") {
          obj.q = { 'label': c.label.qNumber, 'index': indexNo++, 'isCorrect': c.isCorrect, 'isSkiped': c.isSkiped , 'isLabel': true};
        }
        else {
          if (p.length != 0 && p[p.length - 1].q.label == c.label.label.label.qNumber) {
            p[p.length - 1].sq.push({ 'label': c.label.qNumber, 'index': indexNo++ });
            return p;
          } else {
            obj.q = { 'label': c.label.label.label.qNumber,'index': indexNo, 'isCorrect': c.isCorrect, 'isSkiped': c.isSkiped ,'isLabel': false };
            obj.sq.push({ 'label': c.label.qNumber, 'index': indexNo++ });
          }
        }
        return p.concat(obj);
      } else if (c.label.label.label) {
        if (p.length != 0 && p[p.length - 1].q.label == c.label.label.label.qNumber) {
          if (p[p.length - 1].sq[p[p.length - 1].sq.length - 1].label == c.label.label.qNumber) {
            p[p.length - 1].sq[p[p.length - 1].sq.length - 1].ssq.push({ 'label': c.label.qNumber, 'index': indexNo++ });
          } else {
            p[p.length - 1].sq.push({ 'label': c.label.label.qNumber });
            p[p.length - 1].sq[p[p.length - 1].sq.length - 1]['ssq'] = [{ 'label': c.label.qNumber, 'index': indexNo++ }];
          }
          return p;
        } else if (p) {
          obj.q = { 'label': c.label.label.label.qNumber, 'index': indexNo,'isCorrect': c.isCorrect, 'isSkiped': c.isSkiped , 'isLabel': true};
          obj.sq.push({ 'label': c.label.label.qNumber });
          obj.sq[obj.sq.length - 1]['ssq'] = [{ 'label': c.label.qNumber, 'index': indexNo++ }];
          return p.concat(obj);
        } else{
          return p;
        }
      } else{
        return p;
      }

    }, []);
   
    return items;
  }
  showQuestion(answer, number) {
    let qNo: number;
    qNo = number;
    if (qNo != null) {
      this.index = qNo; 
      let questionNumber = this.answerArray[this.index].qId;
      this.getQuestion(questionNumber);
    }
    this.toggelShowHide(answer);
    window.scrollTo(0, 0);
  }
  toggelShowHide(item) {
    this.qNumberArray.map(i => {
      i == item ? i.isOpen = !i.isOpen : i.isOpen = false;
      return i;
    });
  }

  toggleHide(){
    this.qNumberArray = this.qNumberArray.map(i => {
      i.isOpen = false;
      return i;
    });
  }

  // getQuestions() {
  //   this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getQuestionsReleventToSubject, {
  //     [ApiEndpoints.partid]: this.partid
  //   }), { setid: this.cookieManagerService.getCookie(CookieNames.paperSetKey, false), catagoryid: this.categoryid }).subscribe(response => {
  //     let qustionList = response.map((_response) => {
  //       if (_response.isGroup) {
  //         _response.questionType = _response.parentObj.questionType;
  //         _response.lessonUrl = _response.parentObj.lessonUrl;
  //         _response.explanation = _response.parentObj.explanation;
  //       }
  //       _response.answers.map((_answer, _i) => {
  //         if (_answer._id == _response.correctAnswer._id) {
  //           _response.selectedAnswerIndex = _i;
  //         }
  //         if (_response.answeredObj !== null) {
  //           if (_answer._id == _response.answeredObj._id) {
  //             _response.userAnswerIndex = _i;
  //           }
  //         }
  //         return _answer;
  //       });
  //       if (!_response.isGroup) {
  //         _response.explanation = _response.explanation;
  //       }
  //       return _response;
  //     });
  //     this.quections = this.filterQuection = qustionList;

  //   }, error => {
  //     this.ErrorManagerService.setError(error);
  //   });
  // }

  // filter(_id) {
  //   this.clickId = _id;
  //   this.filterQuection = this.quections.filter(
  //     q => q.subCategory._id === _id);
  // }

  // getAll() {
  //   this.clickId = 999;
  //   this.filterQuection = this.quections;
  // }

  subjectCharts() {
    let total = 0;
    if (this.subSubjects) {
      this.subSubjects.forEach(sub => {
        this.doughnutChartLabels.push(sub.subject);
        //this.doughnutChartData.push(sub.wrongAnswerCount);
        this.doughnutChartData.push(sub.typeCount);
        total += sub.typeCount;
      });
    }
    this.doughnutChartData.push(total);
  }
  public doughnutChartLabels: string[] = ['All'];
  public doughnutChartData: number[] = [];
  public doughnutChartType: string = 'doughnut';

  // events
  public chartClicked(e: any) {
    console.log(e);
  }

  public chartHovered(e: any) {
    console.log(e);
  }

  getQuestion(questionNumber) {
    this.qustion = new Question;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getQuestionById, {
      [ApiEndpoints.partid]: this.partid,
      [ApiEndpoints.questionNo]: questionNumber
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      if (!response.isGroup) {
        if (response.questionType == "gr_type_12") {
          response.category = response.category.category;
          this.subcategory = response.subCategory.category;
        } else {
          response.category = response.category.category;
          this.subcategory = response.subCategory.category;
        }
      }
      else {
        if (response.isGroup || ((response.parentObj || false).parentObj || false)) {
          response.questionType = ((response.parentObj.questionType || false)) ? response.parentObj.questionType : ((response.parentObj.parentObj.questionType || false)) ? response.parentObj.parentObj.questionType : '';
          response.lessonUrl = (response.parentObj.lessonUrl) ? response.parentObj.lessonUrl : (response.parentObj.parentObj.lessonUrl) ? response.parentObj.parentObj.lessonUrl : '';
          response.explanation = (response.parentObj.explanation) ? response.parentObj.explanation : (response.parentObj.parentObj.explanation) ? response.parentObj.parentObj.explanation : '';
          response.mark = (response.parentObj.mark) ? response.parentObj.mark : (response.parentObj.parentObj.mark) ? response.parentObj.parentObj.mark : '';
          response.category = (response.parentObj.category.category) ? response.parentObj.category.category : (response.parentObj.parentObj.category.category) ? response.parentObj.parentObj.category.category : '';
          this.subcategory = (response.parentObj.subCategory.category) ? response.parentObj.subCategory.category : (response.parentObj.parentObj.subCategory.category) ? response.parentObj.parentObj.subCategory.category : '';
        }
      }
      response.answers.map((_answer, _i) => {
        if (_answer._id == response.correctAnswer._id) {
          response.selectedAnswerIndex = _i;
        }
        if (response.answeredObj !== null) {
          if (_answer._id == response.answeredObj._id) {
            response.userAnswerIndex = _i;
          }
        }
        return _answer;  //yes or no
      });

      this.qustion = response;
    });
    window.scrollTo(0, 0);
  }

  nextQuection() {
    this.index = this.index + 1;
    let nextQuestionNumber = this.answerArray[this.index].qId;//questionNumber;
    this.getQuestion(nextQuestionNumber);
    this.toggleHide();
  }

  previousQuection() {
    this.index = this.index - 1;
    let previousQuestionNumber = this.answerArray[this.index].qId;//questionNumber;
    this.getQuestion(previousQuestionNumber);
    this.toggleHide();
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report-review.component.ts